import Uri from 'urijs'
import $YTPlayer from 'jquery-youtube-background/src/jquery.youtubebackground'

require('jquery-youtube-background/src/style.css');
export default {

  // add active class if href link is currently visiting
  'active-link': {
    bind() {
      let href = this.el.getAttribute('href')
      let className = this.expression || 'active'

      if (!href) {
        return console.warn(`v-active-link el missing href attribute`)
      }

      if (Uri().segment(0) == Uri(href).segment(0)) this.el.classList.add(className)
    },
  },

  'scroll': {
    params: ['add-class', 'remove-class'],
    bind() {
      const el = this.el
      const addClass = this.params.addClass
      const removeClass = this.params.removeClass
      $(document).on('scroll', function(e) {

        if($(this).scrollTop()+$(window).height() >= (el.offsetTop - el.offsetHeight)) {
          // console.log($(el));
          // console.log($(this).scrollTop())
          // console.log((el.offsetTop - el.offsetHeight))
          // e.stopPropagation()
          if (!_.isUndefined(removeClass)) {
            $(el).removeClass(removeClass)
          }
          if (!_.isUndefined(addClass)) {
            $(el).addClass(addClass)
          }
        }
      })
    }
  },

  'youtube-video-background': {
    params: ['data-url'],
    paramWatchers: {
      dataUrl: function (val, oldVal) {
        // console.log('a changed!')
        // console.log(this)
        const el = this.el
        const youtubeUrl = this.params.dataUrl
        // console.log(youtubeUrl)
        const query = new Uri(youtubeUrl).search(true)
        // console.log(query.v)
        $(el).YTPlayer({
          // optimizeDisplay: true,
          containment: 'self',
          fitToBackground: false,
          showYTLogo: false,
          videoId: query.v
        })
      }
    },
    bind() {}
  }

  // validate: {
  //   bind() {
  //     this.$form = $(this.el)
  //     this.check = {
  //       required: val => {
  //         if (this.el.getAttribute('required')) {
  //           this.vm.validation[name].required = !!val
  //         }
  //       },
  //       email: val => {
  //         let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //         if (type === 'email') { this.vm.validation[name].email = re.test(val) }
  //       },
  //     }
  //
  //     this.vm.valid = true
  //     this.vm.validation = {}
  //     // this.vm.validation[name] = this.vm.validation[name] || { valid: true, }
  //   },
  //
  //   update(val) {
  //     console.log(val);
  //     _.each(this.check, validate => validate(val))
  //
  //     this.vm.validation[name].valid = _.chain(this.vm.validation[name])
  //       .filter((valid, name) => name !=='valid')
  //       .every((valid, name) => valid)
  //       .value()
  //
  //     console.log(this.vm.validation[name].valid, name);
  //
  //     this.vm.valid = _.every(this.vm.validation, (val, name) => val.valid)
  //     console.log(this.vm);
  //     console.log(this.vm.valid, this.vm.validation);
  //   }
  //
  // }

}



// WEBPACK FOOTER //
// ./assets/directive.js